import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Plus } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import GermanDateInput from "@/components/GermanDateInput";

const err = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
const WD = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
const empty = { date: "", from: "09:00", to: "10:00", label: "", movable: true, weekly: false };

export default function InternalBlocksCard({ coachId, onChange }) {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState(empty);
  const params = coachId ? { coach_id: coachId } : {};
  const load = () => api.get("/planner/blocks", { params }).then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, [coachId]); // eslint-disable-line
  const done = () => { load(); onChange(); };
  const add = async () => {
    if (!f.date || !f.label.trim()) { toast.error("Datum und Bezeichnung angeben"); return; }
    try { await api.post("/planner/blocks", f, { params }); setF(empty); toast.success("Interner Termin gespeichert"); done(); } catch (e) { err(e); }
  };
  const toggle = async (b) => { try { await api.put(`/planner/blocks/${b.block_id}`, null, { params: { ...params, movable: !b.movable } }); done(); } catch (e) { err(e); } };
  const del = async (b) => { try { await api.delete(`/planner/blocks/${b.block_id}`, { params }); done(); } catch (e) { err(e); } };
  return (
    <div className="border border-slate-200 bg-white" data-testid="planner-blocks">
      <div className="px-4 py-3 border-b border-slate-100 text-[10px] font-bold uppercase tracking-overline text-slate-500">Interne Termine</div>
      <div className="px-4 py-3 space-y-2 border-b border-slate-100">
        <input value={f.label} onChange={(e) => setF({ ...f, label: e.target.value })} placeholder="z. B. Teammeeting" className="input-tech text-xs" data-testid="block-label" />
        <GermanDateInput value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="block-date" />
        <div className="flex gap-2">
          <input type="time" value={f.from} onChange={(e) => setF({ ...f, from: e.target.value })} className="input-tech text-xs" data-testid="block-from" />
          <input type="time" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} className="input-tech text-xs" data-testid="block-to" />
        </div>
        <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={f.movable} onChange={(e) => setF({ ...f, movable: e.target.checked })} data-testid="block-movable" /> verschiebbar – Planung darf diese Zeit nutzen</label>
        <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={f.weekly} onChange={(e) => setF({ ...f, weekly: e.target.checked })} data-testid="block-weekly" /> jede Woche wiederholen</label>
        <button onClick={add} className="w-full py-2 text-xs border border-slate-900 hover:bg-slate-100 flex items-center justify-center gap-1" data-testid="block-add"><Plus size={12} /> Hinzufügen</button>
      </div>
      {rows.length === 0 && <div className="px-4 py-3 text-xs text-slate-500">Keine internen Termine.</div>}
      {rows.map((b) => (
        <div key={b.block_id} className="px-4 py-2 border-b border-slate-50 text-xs flex items-center justify-between gap-2" data-testid={`block-${b.block_id}`}>
          <div>
            <div className="font-medium">{b.label}</div>
            <div className="text-slate-500">{b.weekly ? `jeden ${WD[(new Date(`${b.date}T12:00:00`).getDay() + 6) % 7]}` : b.date.split("-").reverse().join(".")} · {b.from}–{b.to}</div>
          </div>
          <div className="flex items-center gap-1.5">
            <button onClick={() => toggle(b)} data-testid={`block-toggle-${b.block_id}`}
              className={`text-[10px] px-2 py-1 border ${b.movable ? "border-emerald-300 text-emerald-700 bg-emerald-50" : "border-slate-300 text-slate-700"}`}>
              {b.movable ? "verschiebbar" : "verbindlich"}
            </button>
            <button onClick={() => del(b)} className="p-1 text-rose-600 hover:bg-rose-50" data-testid={`block-delete-${b.block_id}`}><Trash2 size={12} /></button>
          </div>
        </div>
      ))}
    </div>
  );
}
